import { parseUTCDate } from "../../utils/dateUtils";

export type DateBadgeSize = "xs" | "sm" | "md" | "lg" | "xl";

const SIZES: Record<DateBadgeSize, { box: string; month: string; day: string }> = {
  xs: { box: "w-9 h-9", month: "text-[7px]", day: "text-xs" },
  sm: { box: "w-10 h-10", month: "text-[8px]", day: "text-sm" },
  md: { box: "w-11 h-11", month: "text-[9px]", day: "text-base" },
  lg: { box: "w-12 h-12", month: "text-[10px]", day: "text-lg" },
  xl: { box: "w-14 h-14", month: "text-[10px]", day: "text-xl" },
};

// Calendar-style date chip — month abbreviation over the day number on a black
// tile. Shared across every event/kiki surface so date indicators look the same.
export function DateBadge({
  date,
  size = "md",
  className = "",
}: {
  date: string;
  size?: DateBadgeSize;
  className?: string;
}) {
  const parsed = parseUTCDate(date);
  const s = SIZES[size];
  return (
    <div
      className={`flex flex-col items-center justify-center border rounded-xl border-content bg-neutral-50/75 dark:bg-black/75 shrink-0 ${s.box} ${className}`}
    >
      <span className={`font-bold uppercase tracking-wider text-primary-400 leading-none ${s.month}`}>
        {parsed.monthShort}
      </span>
      <span className={`font-bold leading-tight mt-0.5 ${s.day}`}>{parsed.day}</span>
    </div>
  );
}
